import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Optional } from '@angular/core';
import { OAuthModuleConfig, OAuthResourceServerErrorHandler, OAuthService } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class IdTokenOAuthInterceptor implements HttpInterceptor {
  constructor(
    private authService: OAuthService,
    private errorHandler: OAuthResourceServerErrorHandler,
    @Optional() private moduleConfig: OAuthModuleConfig,
  ) {}

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const url = req.url.toLowerCase();

    if (!this.moduleConfig || !this.moduleConfig.resourceServer || !this.moduleConfig.resourceServer.allowedUrls || !this.checkUrl(url)) {
      return next.handle(req);
    }

    const sendAccessToken = this.moduleConfig.resourceServer.sendAccessToken;

    if (sendAccessToken) {
      // here we use the id_token instead of the access token because we only have usable id_tokens in JWT format from Netscaler
      const token = this.authService.getIdToken();
      const header = 'Bearer ' + token;

      const headers = req.headers.set('Authorization', header);

      req = req.clone({ headers });
    }

    return next.handle(req).pipe(catchError((err) => this.errorHandler.handleError(err)));
  }

  private checkUrl(url: string): boolean {
    const found = this.moduleConfig.resourceServer.allowedUrls!.find((u) => url.startsWith(u));
    return !!found;
  }
}
